import { render, staticRenderFns } from "./TableQuestion.vue?vue&type=template&id=605bde2c&"
import script from "./TableQuestion.vue?vue&type=script&lang=js&"
export * from "./TableQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports